<template>
  <div class="radio-group">
    <template v-for="(item, index) in items" :key="index">
      <input
        :id="`option-${item.value}`"
        v-model="selectedItem"
        type="radio"
        name="mode-selector"
        :value="item.value"
      >
      <label
        :for="`option-${item.value}`"
        :title="item.display"
        :active="selectedItem === item.value"
      >
        {{ item.display }}
      </label>
    </template>
  </div>
</template>

<script setup>
import { ref, watch, toRefs } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: String,
    default: "",
  },
});

const { items, modelValue } = toRefs(props);

const emit = defineEmits(['update:modelValue']);

const selectedItem = ref(modelValue.value);

watch(modelValue, (newVal) => {
  if (newVal !== selectedItem.value) {
    selectedItem.value = newVal;
  }
});

watch(selectedItem, (newVal) => {
  if (newVal !== modelValue.value) {
    emit('update:modelValue', newVal);
  }
});
</script>

<style lang="scss" scoped>
.radio-group {
  width: fit-content;
  margin: 0;
  flex-wrap: wrap;
  display: flex;
  border-radius: 100vw;
  padding: 5px;
  gap: 5px;
  box-shadow: none !important;

  input[type=radio] + label {
    width:fit-content;
    max-width: fit-content;
    flex-wrap: nowrap;
    font-size: 0.875rem;
    font-weight: bold !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 100vw;

    &[active="true"] {
      background: var(--color-primary) !important;
    }

    &:hover:not([active="true"]){
      background: var(--color-primary-200) !important;
    }
  }
}
</style>
